import {Button, IconButton} from '@material-ui/core';
import {Close} from '@material-ui/icons';
import * as I from 'immutable';
import React from 'react';
import {useDispatch} from 'react-redux';
import AgentSupportPermissionsInput from 'Users/components/UserAdministration/UserEntry/Agent/AgentSupportPermissionsInput';
import TaxIdInput from 'Users/components/UserAdministration/UserEntry/TaxIdInput';
import {addAgencyAssociation, changeTaxId, removeAgencyAssociation} from 'Users/ducks/agentSupportUserType';
import {AgentSupportUserType} from 'Users/models/User/Agent/AgentSupportUserType';
import {SupportAgencyAssociation} from 'Users/models/User/Agent/SupportAgencyAssociation';
import {matchTaxIdentificationNumber} from 'Users/models/User/Agent/TaxIdentificationNumber';
import './AgentPortalEntry.sass';

type AgentSupportUserTypeEntryProps = {
  agentSupportUserType: AgentSupportUserType;
  hasUpdateAccess: boolean;
  isEdit: boolean;
};

const AgentSupportUserTypeEntry = (props: AgentSupportUserTypeEntryProps) => {
  const dispatch = useDispatch();
  const {agentSupportUserType, hasUpdateAccess, isEdit} = props;
  const agencyAssociations: I.List<SupportAgencyAssociation> = agentSupportUserType.agencyAssociations;

  return (
    <div className="agent-portal-entry-section">
      {agencyAssociations.map(({taxId, supportAgentPermissions, agentNumbers}, index) => {
        return (
          <div className="agent-portal-entry-section__agency-association-section" key={`association-${index}`}>
            <IconButton
              className="agency-association-section__remove-association-button"
              onClick={() => dispatch(removeAgencyAssociation(index))}
              disabled={!hasUpdateAccess && isEdit}
            >
              <Close />
            </IconButton>
            <h2 className="agency-association-section__agency-association-label">Agency Association {index + 1}</h2>
            <TaxIdInput
              className="agency-association-section__tax-id-input"
              taxId={taxId}
              onChange={taxId => dispatch(changeTaxId(index, taxId))}
              disabled={!hasUpdateAccess && isEdit}
            />
            {matchTaxIdentificationNumber(taxId, {
              ValidTaxIdentificationNumber: validTaxId => (
                <AgentSupportPermissionsInput
                  taxId={validTaxId}
                  index={index}
                  agentNumbers={agentNumbers}
                  supportAgentPermissions={supportAgentPermissions}
                  disabled={!hasUpdateAccess && isEdit}
                />
              ),
              ExistingTaxIdentificationNumber: existingTaxId => (
                <AgentSupportPermissionsInput
                  taxId={existingTaxId}
                  index={index}
                  agentNumbers={agentNumbers}
                  supportAgentPermissions={supportAgentPermissions}
                  disabled={!hasUpdateAccess && isEdit}
                />
              ),
              Default: () => null,
            })}
          </div>
        );
      })}
      <Button
        className="agent-portal-entry-section__add-new-association-button"
        color="primary"
        onClick={() => dispatch(addAgencyAssociation())}
        disabled={!hasUpdateAccess && isEdit}
      >
        Add New Association
      </Button>
    </div>
  );
};

export default AgentSupportUserTypeEntry;
